import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UtilsService } from 'src/app/shared/services/utils-service/utils.service';

@Component({
  selector: 'app-assignee-group-template',
  templateUrl: './assignee-group-template.component.html',
  styleUrls: ['./assignee-group-template.component.scss']
})
export class AssigneeGroupTemplateComponent implements OnInit {

  constructor(public utils: UtilsService){

  }
  @Input() memberList: any = [];
  @Input() followerList: any = [];

  originalMemberList:any[] = [];
  originalFollowerList:any[] = [];

  @Input() patchId:any[] = [];
  @Input() patchFollowerId:any[] = [];

  @Input() selectGroupType:string = '';
  @Output('selectedId') selectedId = new EventEmitter();

  @Input() selectedTemplateType:string='';


  selectedFollowerItems:any = [];
  selectedItems:any = [];

  selectedGroup: string | null = null;

  dropdownSettings = {
    singleSelection: false,
    enableCheckAll: false,
    text: "Select Assignees/Groups",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    groupBy: "group",
    selectGroup: true,
    searchBy: ['itemName'],
    tagToBody: false,
    noDataLabel: 'No data found',
    showClearAll: false,
    showClear: false,
    badgeShowLimit: 3
  };

  followerDropdownSettings = {
    singleSelection: false,
    enableCheckAll: false,
    text: "Select Follower",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    groupBy: "group",
    selectGroup: true,
    searchBy: ['itemName'],
    tagToBody: false,
    noDataLabel: 'No data found',
    showClearAll: false,
    showClear: false,
    badgeShowLimit: 3
  };

  ngOnInit() {
    this.originalFollowerList =  JSON.parse(JSON.stringify(this.followerList));
    this.originalMemberList =  JSON.parse(JSON.stringify(this.memberList));
    
    if(this.patchId?.length && this.selectGroupType){
      this.selectedGroup = this.selectGroupType;

      const patchID:any = this.patchId?.map((data:any)=> data.id);
      this.selectedItems = this.memberList.filter(
        (member:any) => member.group === this.selectedGroup && patchID.includes(member.id)
      );
      
    }

    if(this.patchFollowerId?.length){
      const patchID:any = this.patchFollowerId?.map((data:any)=> data.id);
      this.selectedFollowerItems = this.followerList.filter(
        (member:any) => patchID.includes(member.id)
      );
    }
    this.syncStateAndEmit();
  }

  onItemSelect(_event?: any) {
    this.syncStateAndEmit();
  }

  onItemDeSelect(_event?: any) {
    this.syncStateAndEmit();
  }

  onSelectAll(_event?: any) {
    this.syncStateAndEmit();
  }

  onDeSelectAll(_event?: any) {
    this.syncStateAndEmit();
  }

  private resolveSelectedGroupFromSelection(): string | null {
    const selectedTypes = Array.from(
      new Set(
        (this.selectedItems || [])
          .map((item: any) => item?.group)
          .filter((groupType: string) => groupType === 'group' || groupType === 'member')
      )
    );
    if (selectedTypes.length === 1) {
      return selectedTypes[0] as string;
    }
    return null;
  }

  private rebuildMemberListWithFollowerExclusions(): void {
    const selectedFollowerIds =
      this.selectedFollowerItems
        ?.filter((ele:any)=>ele.group=='member')
        ?.map((item: any) => Number(item.id)) || [];

    const groupItems =
      this.originalMemberList?.filter((ele:any)=>ele.group=='group') || [];
    const memberItems =
      this.originalMemberList?.filter(
        (ele:any)=>ele.group=='member' && !selectedFollowerIds.includes(Number(ele.id))
      ) || [];

    this.memberList = [...groupItems, ...memberItems];
  }

  private applyDisabledState(): void {
    this.selectedGroup = this.resolveSelectedGroupFromSelection();
    this.memberList = (this.memberList || []).map((item:any) => ({
      ...item,
      disabled: !!this.selectedGroup && item.group !== this.selectedGroup
    }));
  }

  private syncStateAndEmit(): void {
    setTimeout(() => {
      this.updateFollowerList();
      this.rebuildMemberListWithFollowerExclusions();
      this.applyDisabledState();
      this.selectedIdEvent();
    }, 0);
  }

  selectedIdEvent(){
    this.selectedId.emit({task_member:this.selectedItems,task_follower:this.selectedFollowerItems});
  }


  updateFollowerList() {
    const selectedMemberIds = this.selectedItems?.filter((ele:any)=>ele.group=='member')?.map((item: any) => item.id) || [];
    const selectedGroupsMemberIds = (this.selectedItems?.filter((ele:any)=>ele.group=='group')?.map((item: any) => item.members_details).flat()) || [];

    const idsToRemove = new Set([...selectedMemberIds, ...selectedGroupsMemberIds]);
    
    // Remove from followerList
    this.followerList = this.originalFollowerList.filter((follower: any) => !idsToRemove.has(follower.id));
  
    // Unselect selectedFollowerItems if they exist in group members
    if (this.selectedFollowerItems) {
      this.selectedFollowerItems = this.selectedFollowerItems.filter((follower: any) => !selectedGroupsMemberIds.includes(follower.id));
    }
  }

  onFollowerItemSelect(_event?: any) {
    this.syncStateAndEmit();
  }
}
